
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"52","height":"52"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M41.719 43.508h-29.09a10.249 10.249 0 01-1.123-.052 12.568 12.568 0 01-3.639-24.179 15.936 15.936 0 015.645-8.077 15.9 15.9 0 0123.372 4.83 11.077 11.077 0 019.316 8.022A10.23 10.23 0 0142.038 43.5c-.103.008-.199.008-.319.008zM23.072 13.415a10.412 10.412 0 00-10.443 10.357h-.005a7.155 7.155 0 00-.575 14.291 3.977 3.977 0 00.58.028h29.209a4.825 4.825 0 00-.119-9.649 4.926 4.926 0 00-.735.052A5.6 5.6 0 0041.191 27a5.674 5.674 0 00-5.69-5.646 5.58 5.58 0 00-2.185.431 10.415 10.415 0 00-10.244-8.37z","fill":"#222"}})])
          )
        }
      }
    